import React from "react";
import styled from "styled-components";

export interface CardLayoutFieldProps
  extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
}

const CardLayoutField = ({
  label,
  children,
  ...rest
}: CardLayoutFieldProps) => {
  return (
    <WrapStyle {...rest}>
      <LabelStyle>{label}</LabelStyle>
      <ContentStyle>{children}</ContentStyle>
    </WrapStyle>
  );
};

export default CardLayoutField;

export const WrapStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const LabelStyle = styled.div`
  ${({ theme }) => theme.typography.body1.medium}
`;

export const ContentStyle = styled.div``;
